import { render, staticRenderFns } from "./RetentionDetail.vue?vue&type=template&id=cd1f8c88"
import script from "./RetentionDetail.vue?vue&type=script&lang=js"
export * from "./RetentionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports